module.exports = __webpack_public_path__ + "img/20190516105221btn_8_03.87413584.png";